export default "__VITE_PUBLIC_ASSET__90e3f4c7__"